export default "__VITE_ASSET__RaaPW5s4__"